import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const button: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  px: 1,
  minWidth: 0,
};
